<template>
  <div class="container">
    <div class="commodity">
      <div class="commodity-img">
        <div class="comimg">
          <img :src="goodInfo.goodsImgUrl" alt="" width="100%" />
        </div>
        <div class="commodity-content">
          <span class="title">{{ goodInfo.goodsName }}</span>
          <span class="text">黑色和米白色桑蚕丝斜纹</span>
          <span class="count">x{{ goodInfo.goodsNum }}</span>
        </div>
      </div>
    </div>
    <div
      class="Payment"
      :class="{ active: shows == 1 }"
      @click="toApplyAfter(1)"
    >
      <div class="payspan">
        <span class="refund">仅退款</span>
        <span class="payagree">未确认收货，与商家协商同意退款</span>
      </div>
      <div class="payimg">
        <img src="../../../assets/icon/icon_more.png" alt="" width="100%" />
      </div>
    </div>
    <div
      class="Payment"
      :class="{ active: shows == 2 }"
      @click="toApplyAfter(3)"
    >
      <div class="payspan">
        <span class="refund">退货退款</span>
        <span class="payagree">商品存在质量问题，与卖家协商同意退款</span>
      </div>
      <div class="payimg">
        <img src="../../../assets/icon/icon_more.png" alt="" width="100%" />
      </div>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/api";
export default {
  data() {
    return {
      value: "",
      currentClass: 0,
      shows: true,
      orderNo: this.$route.query.orderNo, // 订单号
      goodsId: this.$route.query.goodsId, // 商品id
      goodInfo: {}, // 商品信息
    };
  },
  methods: {
    toggleTab(current) {
      this.currentClass = current;
    },
    // 跳转申请售后页
    toApplyAfter(type) {
      this.$router.push({
        path:
          "/orders/onlyRefund?orderNo=" +
          this.orderNo +
          "&goodsId=" +
          this.goodsId +
          "&afterType=" +
          type,
      });
    },
    // 获取订单详情
    async getData() {
      const params = {
        orderNo: this.orderNo,
      };
      const res = await getOrderDetail(params);
      if (res.code == "0000") {
        // 通过子订单号码获取到对应的子订单信息
        // 再通过商品ID获取到对应的商品信息
        const list = res.data.orderList;
        list.forEach((item) => {
          if (item.orderNo == this.orderNo) {
            item.goodsInfoList.forEach((itm) => {
              if (this.goodsId == itm.goodsId) {
                this.goodInfo = itm;
              }
            });
          }
        });
      } else {
        this.$toast(res.msg);
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.container {
  .commodity {
    background-color: #fff;
    padding: 0 20px;
    margin-bottom: 20px;

    .commodity-img {
      border-top: 1px solid #999999;
      padding: 15px 20px 20px 20px;
      display: flex;

      span {
        display: block;
      }

      .commodity-content {
        padding-left: 20px;

        .title {
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          padding-bottom: 10px;
        }

        .text {
          font-size: 26px;
          font-weight: 500;
          color: #999999;
          line-height: 37px;
          padding-bottom: 33px;
        }

        .count {
          font-size: 28px;
          font-weight: 500;
          color: #333333;
          line-height: 40px;
          text-align: right;
        }
      }

      .comimg {
        width: 180px;
        height: 180px;

        img {
          border-radius: 8px;
        }
      }
    }
  }

  .Payment {
    height: 145px;
    padding: 0 40px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .payspan {
      span {
        display: block;
      }

      .refund {
        font-size: 28px;
        font-family: Helvetica;
        color: #333333;
        line-height: 34px;
        padding-bottom: 5px;
      }

      .payagree {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #999999;
        line-height: 40px;
      }
    }

    .payimg {
      width: 32px;
      height: 32px;
    }
  }
  // .Payment.active {
  //   background-color: #fff;
  //   color: #fff;
  //   .refund {
  //     color: #fff;
  //   }
  //   .payagree {
  //     color: #fff;
  //   }
  // }
}
</style>
